
<div class="container my-4 contactContent" id="">
  <h3 class="page-title">{{'ContactAssessor.TitleBusiness'|translate}}</h3>
  <p style="font-style: italic"><strong>{{'ContactAssessor.Number'|translate}} </strong></p>
  <hr>
    <form [formGroup]="contactForm" (ngSubmit)="submit()">
      <p class="form-label">{{'ContactAssessor.Name'|translate}} <span class="color-red">*</span></p>
      <div class="form-row" style="display: flex; align-items: flex-start; flex-wrap: nowrap; gap: 10px; margin-bottom: 20px;">
        <div class="form-group col-md-6" style="display: flex; flex-direction: column; align-items: center; width: 49%;">

          <input type="text" formControlName="firstName" class="form-control" id="inputFirst-General" placeholder="{{'ContactAssessor.FirstName' | translate}}">
          <div class="invalid-feedback" style="display: block">
            @if (hasError('firstName', 'required')) {
              {{'ContactAssessor.Required'|translate}}
            }
          </div>
        </div>
        <div class="form-group col-md-6">
          <input type="text" formControlName="lastName" class="form-control" id="inputLast-General" placeholder="{{'ContactAssessor.LastName' | translate}}">
          <div class="invalid-feedback" style="display: block">
            @if (hasError('lastName', 'required')) {
              {{ 'ContactAssessor.Required' | translate}}
            }
          </div>
        </div>
      </div>
      <div class="form-group">
        <p class="form-label" style="margin-top: 20px;">{{ 'ContactAssessor.Email' | translate}} <span class="color-red">*</span></p>
        <input type="email" class="form-control" formControlName="email" placeholder="{{'ContactAssessor.Email' | translate}}">
        <div class="invalid-feedback" style="display: block">
          @if (hasError('email', 'required')) {
            {{ 'ContactAssessor.Required' | translate}}
          }
        </div>
      </div>
      <p class="form-label" style="margin-top: 20px;">{{ 'ContactAssessor.Phone' | translate}}  <span class="color-red">*</span></p>
      <div class="form-row">
        <div class="form-group col-12">
          <input class="form-control"  type="text" appPhoneMask placeholder="{{'ContactAssessor.Phone' | translate}}"  formControlName="phone" id="inputPhone-General"  >
          <div class="invalid-feedback" style="display: block">
            @if (hasError('phone', 'required')) {
              {{ 'ContactAssessor.Required' | translate}}
            }
          </div>
        </div>
      </div>

      <p class="form-label" style="margin-top: 20px;">
        {{'ContactAssessor.SpecificRadio' | translate}} <span class="color-red">*</span>
      </p>
      <div class="form-group d-flex align-items-center gap-3">
        <div class="form-check">
          <input class="form-check-input" formControlName="businessDescription" value="0" name="businessDescription" type="radio" id="marineAircraft">
          <label class="form-check-label" for="marineAircraft">{{'ContactAssessor.MarineAndAircraft' | translate}}</label>
        </div>

        <div class="form-check">
          <input class="form-check-input" formControlName="businessDescription" value="1" name="businessDescription" type="radio" id="mobileHome">
          <label class="form-check-label" for="mobileHome">{{'ContactAssessor.MobileHome' | translate}}</label>
        </div>

        <div class="form-check">
          <input class="form-check-input" formControlName="businessDescription" value="2" name="businessDescription" type="radio" id="otherBusiness">
          <label class="form-check-label" for="otherBusiness">{{'ContactAssessor.OtherBusiness' | translate}}</label>
        </div>



      </div>
      <div class="invalid-feedback" style="display: block">
        @if (hasError('businessDescription', 'required')) {
          {{ 'ContactAssessor.Required' | translate}}
        }
      </div>

      <div class="form-row" style="display: flex; align-items: flex-start; flex-wrap: nowrap; gap: 10px; margin-bottom: 20px;">

        <div class="form-group col-md-6" style="width: 49%;">
          <label class="form-label" style="margin-top: 20px;">{{ 'ContactAssessor.AssesmentNumberv2' | translate}}</label>
          <input type="text" formControlName="assessment" class="form-control" id="" >

        </div>
        <div class="col-md-6">
          <label class="form-label" style="margin-top: 20px;">{{ 'ContactAssessor.IndexNumber' | translate}}</label>
          <input type="text" formControlName="index" class="form-control" id="" >

        </div>

      </div>

      <p class="form-label" style="margin-top: 20px;">{{'ContactAssessor.Address'| translate}} <span class="color-red">*</span></p>
      <app-certificate-address
        [parentFormGroup]="contactForm"
        streetNumber="number"
        streetDirection="direction"
        streetName="street"
        streetType="type"
        unitNumber="unit"
        city="city"
        zipCode="zipCode"
        >
      </app-certificate-address>


      <p class="form-label" style="margin-top: 20px;">{{ 'ContactAssessor.Description' | translate}}</p>
      <div class="form-group">

        <textarea class="form-control" formControlName="description"  id="inputDescription-General" rows="4" placeholder="Type here"></textarea>
      </div>
      <p class="form-label" style="margin-top: 20px;">{{ 'ContactAssessor.Attachment' | translate}} (PDF or Docx)</p>
      <div class="form-group">
        <app-file-upload formControlName="file" [progress]="progress"></app-file-upload>
        <div class="invalid-feedback" style="display: block">
          @if (hasError('file', 'required')) {
            {{ 'ContactAssessor.Required' | translate}}
          }
          @if (hasError('file', 'requiredFileType')) {
            Only PDF, Docx
          }
          @if (hasError('file', 'requiredFileSize')) {
            Size to exceeds 10 MB
          }
        </div>
      </div>


      <div class="form-group" style="margin-top: 15px;">
        <app-captcha [form]="contactForm" captchaFieldName="recaptchaReactive"></app-captcha>
        <div class="invalid-feedback" style="display: block">
          @if (hasError('recaptchaReactive', 'required')) {
            {{ 'ContactAssessor.Required' | translate}}
          }
        </div>
      </div>

      <button type="submit" class="btn btn-primary mr-4" style="margin-top: 15px;">Submit</button>@if (success) {
      <span>Successfully Submitted</span>
    }

  </form>

</div>
